module.exports = __webpack_public_path__ + "static/media/OP_Portal_Main_logo.625cc244.svg";